import { apiCall } from '../apiServerHelper'
import { apis } from '../apiUrls'

export const sendEvent = (data) => {
  return apiCall(apis.FACEBOOK_CONVERSION, data, 'POST')
}
